import {
  //Загрузка информации о сообщении
  MESSAGE_INFO_LOADING_START,
  MESSAGE_INFO_LOADED_SUCCESSFULLY,
  MESSAGE_INFO_LOADING_FAILED,

  //Удаление сообщения
  MESSAGE_DELETION_START,
  MESSAGE_DELETED_SUCCESSFULLY,
  MESSAGE_DELETION_FAILED,
} from '../actions/messageInfo';

import { SIGN_OUT } from '../actions/auth';

const INITIAL_STATE = {
  ready: false,
  loading: false,
  message: {},
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    //Загрузка информации о сообщении
    case MESSAGE_INFO_LOADING_START:
      return {
        ...state,
        ready: false,
        loading: true,
        message: {},
      };
    case MESSAGE_INFO_LOADED_SUCCESSFULLY:
      return {
        ...state,
        ready: true,
        loading: false,
        message: action.payload.message,
      };
    case MESSAGE_INFO_LOADING_FAILED:
    case MESSAGE_DELETION_FAILED:
      return {
        ...state,
        ready: false,
        loading: false,
      };
    //Удаление сообщения
    case MESSAGE_DELETION_START:
      return {
        ...state,
        ready: false,
        loading: true,
      };
    case MESSAGE_DELETED_SUCCESSFULLY:
      return {
        ...state,
        ready: false,
        loading: false,
        message: {},
      };
    case SIGN_OUT:
      return INITIAL_STATE;
    default:
      return state;
  }
}